import { ReactElement } from "react";
import { SET_CONFIRM_POPUP, SET_INFO_POPUP } from "./action-types";

export interface IPopupState {
    confirmPopup: IConfirmPopupState;
    infoPopup: IInfoPopupState;
}

export interface IConfirmPopupState {
    isOpen: boolean;
    title?: string;
    message?: string;
    content?: ReactElement;
    onConfirm?: () => void;
    onDismiss?: () => void;
    confirmButtonText?: string;
    dismissButtonText?: string;
}

export interface IInfoPopupState {
    isOpen: boolean;
    message?: string;
    onDismiss?: () => void;
}

const initialState: IPopupState = {
    confirmPopup: {} as IConfirmPopupState,
    infoPopup: {} as IInfoPopupState,
};

const popupReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CONFIRM_POPUP:
            return {
                ...state,
                confirmPopup: {
                    ...action.props,
                },  
            };

        case SET_INFO_POPUP:
            return {
                ...state,
                infoPopup: {
                    ...action.props,
                },  
            };

        default:
            return state;
    }
};

export default popupReducer;
